import React, { useState, useEffect, useContext, useRef } from "react";
//import { renderCount } from '../../../../appHelpers/appLoggers';
import styled from "styled-components";
import { SegmentedPicker, Button, GlassCard } from "../../../../ui";
import { colors } from "../../../../ui/theme/colors";
import { AccessListFC } from "./AccessListFC";
import { ProfileSettings } from "./ProfileSettings";
import { AlertSettingsFC } from "./AlertSettingsFC";
import axiosInstance from "../../../../../appHelpers/axiosInstance";
import { useAuth0 } from "@auth0/auth0-react";
import { RecentActivity } from "./RecentActivty";
import { useHistory, useParams } from "react-router-dom";

import { UserAlerts } from "./UserAlerts";
import { UserContext } from "../../_context/UserContext";
import { LoaderFC } from "../../_helpers/LoaderFC";
import { ReportSettingsFC } from "./ReportSettingsFC";

export const _UserFC = (props) => {
  // renderCount(`AdminFC`);
  const { getUserProfile, userRoles } = useContext(UserContext);

  let history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [user, setUser] = useState();
  const [active, setActive] = useState("Profile");
  const [baseSettings, setBaseSettings] = useState([]);
  const [loadingUser, setLoadingUser] = useState([]);
  const [loadingBaseSettings, setLoadingBaseSettings] = useState([]);
  const { id } = useParams();

  const getNavigationOptions = () => {
    const options = [
      { eventKey: "Profile", label: "Profile" },
      { eventKey: "Alerts", label: "Alerts" },
      { eventKey: "Reports", label: "Reports" },
    ];

    if (
      userRoles.includes("admin") ||
      userRoles.includes("superuser") ||
      userRoles.includes("site-admin")
    ) {
      options.push(
        { eventKey: "Access", label: "Access" },
        { eventKey: "AlertHistory", label: "History" },
        // Note: Activity is disabled in original, so excluding it for now
      );
    }

    return options;
  };

  // Retries User Profile Information Based on the User ID (param) that is given.
  const getUserProfileSettings = async () => {
    try {
      const token = await getAccessTokenSilently({
        audience: `${process.env.REACT_APP_AUTH0_EXPRESS_API}`,
      });

      const getUserProfile = await axiosInstance({
        url: `/user/profile/${id}`,
        data: ``,
        headers: { authorization: `Bearer ${token}` },
      });

      setUser(getUserProfile?.data[0][0]);
    } catch (error) {
      console.error(error);
    }
    setLoadingUser(false);
  };

  // Gets The Base System From the User Viewing the Profile (Usually Admin)
  const getBaseSettings = async () => {
    try {
      const token = await getAccessTokenSilently({
        audience: `${process.env.REACT_APP_AUTH0_EXPRESS_API}`,
      });

      const baseSystemsRes = await axiosInstance({
        url: `/admin/base/machines`,
        data: ``,
        headers: { authorization: `Bearer ${token}` },
      });

      setBaseSettings(baseSystemsRes?.data[0]);
    } catch (error) {
      console.error(error);
    }
    setLoadingBaseSettings(false);
  };

  useEffect(() => {
    getUserProfile();
  }, [props]);

  useEffect(() => {
    getUserProfileSettings();
    getBaseSettings();
  }, [id]);

  return (
    <>
      {loadingUser || loadingBaseSettings ? (
        <LoaderFC />
      ) : // Desktop View
      window.screen.width >= 768 ? (
        <_UserSC>
          <BackButtonContainer>
            <Button
              variant="secondary"
              size="medium"
              onClick={() => history.goBack()}
            >
              ← Back
            </Button>
          </BackButtonContainer>

          <ContentWrapper>
            <UserProfileCard>
              <UserPane>
                <ModernAvatar>
                  {(user.first_name ? user.first_name.charAt(0) : "") +
                    " " +
                    (user.last_name ? user.last_name.charAt(0) : "")}
                </ModernAvatar>
                <UserName>
                  {(user.first_name ? user.first_name : "") +
                    " " +
                    (user.last_name ? user.last_name : "")}
                </UserName>

                <ItemSubText>
                  {Object.values(user?.roles["roles"].join(", "))}
                </ItemSubText>
              </UserPane>
            </UserProfileCard>

            <NavigationContainer>
              <SegmentedPicker
                options={getNavigationOptions()}
                activeKey={active}
                onSelect={setActive}
                variant="glass"
                size="medium"
              />
            </NavigationContainer>
          </ContentWrapper>

          <SettingPane>
            {active === "Profile" ? (
              <ProfileSettings user={user} roles={userRoles} />
            ) : active === "Access" ? (
              <AccessListFC
                baseSystems={baseSettings}
                user={user.email_address}
              />
            ) : active === "AlertHistory" ? (
              <UserAlerts user={user.email_address} />
            ) : active === "Alerts" ? (
              <AlertSettingsFC baseSystems={baseSettings} user={user} />
            ) : active === "Reports" ? (
              <ReportSettingsFC />
            ) : active === "Activity" ? (
              <RecentActivity />
            ) : null}
          </SettingPane>
        </_UserSC>
      ) : (
        // Mobile View
        <_UserSC>
          <BackButtonContainer>
            <Button
              variant="secondary"
              size="medium"
              onClick={() => history.goBack()}
            >
              ← Back
            </Button>
          </BackButtonContainer>

          <ContentWrapper>
            <UserProfileCard>
              <UserPane>
                <ModernAvatar>
                  {(user.first_name ? user.first_name.charAt(0) : "") +
                    " " +
                    (user.last_name ? user.last_name.charAt(0) : "")}
                </ModernAvatar>
                <UserName>
                  {(user.first_name ? user.first_name : "") +
                    " " +
                    (user.last_name ? user.last_name : "")}
                </UserName>

                <ItemSubText>
                  {Object.values(user?.roles["roles"].join(", "))}
                </ItemSubText>
              </UserPane>
            </UserProfileCard>

            <NavigationContainer>
              <SegmentedPicker
                options={getNavigationOptions()}
                activeKey={active}
                onSelect={setActive}
                variant="glass"
                size="small"
              />
            </NavigationContainer>
          </ContentWrapper>

          <SettingPane>
            {active === "Profile" ? (
              <ProfileSettings user={user} roles={userRoles} />
            ) : active === "Access" ? (
              <AccessListFC
                baseSystems={baseSettings}
                user={user.email_address}
              />
            ) : active === "Alerts" ? (
              <UserAlerts user={user.email_address} />
            ) : active === "Activity" ? (
              <RecentActivity />
            ) : (
              <></>
            )}
          </SettingPane>
        </_UserSC>
      )}
    </>
  );
};

const _UserSC = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 0 20px 40px 20px;
  color: ${({ theme, darkMode }) =>
    darkMode ? theme.dark_accent : theme.light_accent};

  @media screen and (max-width: 768px) {
    padding: 0 16px 24px 16px;
  }
`;

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-top: 8px;

  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
    padding-top: 8px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    gap: 16px;
  }
`;

const UserProfileCard = styled(GlassCard)`
  padding: 32px;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 24px;
  }
`;

const NavigationContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const SettingPane = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 24px auto 0 auto;

  @media screen and (max-width: 768px) {
    margin: 16px auto 0 auto;
  }
`;

const UserPane = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const UserName = styled.h2`
  font-size: 1.8em;
  font-weight: 600;
  margin: 0;
  color: ${colors.primary.main};
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 1.5em;
  }
`;

const ModernAvatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  font-size: 28px;
  font-weight: 700;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    ${colors.primary.main} 0%,
    ${colors.primary.dark} 100%
  );
  box-shadow: 0 8px 24px rgba(44, 90, 160, 0.3);
  border: 3px solid rgba(255, 255, 255, 0.2);

  @media screen and (max-width: 768px) {
    width: 70px;
    height: 70px;
    font-size: 24px;
  }
`;

const ItemSubText = styled.div`
  font-size: 0.95em;
  color: ${colors.neutral[600]};
  font-weight: 500;
  text-align: center;
  padding: 8px 16px;
  background: rgba(44, 90, 160, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(44, 90, 160, 0.2);

  @media screen and (max-width: 768px) {
    font-size: 0.9em;
  }
`;
